import React from "react";
import MediaKitSection from "../../components/Media/MediaKit.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
// import PartnerWithAptechSection from "../components/PartnerWithAptech/PartnerWithAptech.tsx";
const MediaKit = () => {
  return (
    <>
      <MetaComponent
        title="Official Media Kit of Aptech Limited with the Brand & Company Info"
        desc="Explore Aptech's media kit to access company facts, brand guidelines, and key resources about a global leader in vocational training. View now"
        keywords="vocational training, skill development, Aptech Media Kit."
      />
      <MediaKitSection />
    </>
  );
};

export default MediaKit;
